(function () {
  "use strict";

  document.querySelectorAll("[data-ph-article-content]").forEach(function (content) {
    if (content.dataset.phArticleEnhanced === "true") return;

    try {
      var cta = content.querySelector("[data-ph-article-cta]");
      if (!cta) {
        content.dataset.phArticleEnhanced = "true";
        return;
      }

      var paragraphs = content.querySelectorAll("p");
      if (paragraphs.length < 2) {
        content.dataset.phArticleEnhanced = "true";
        return;
      }

      var secondParagraph = paragraphs[1];
      if (!secondParagraph.parentNode) return;
      secondParagraph.parentNode.insertBefore(cta, secondParagraph.nextSibling);
      content.dataset.phArticleEnhanced = "true";
    } catch (error) {
      // Preserve the server-rendered end-of-article fallback on enhancement errors.
    }
  });
})();
